import { VerificationRequestType } from 'src/api';
import { EMPLOYMENT_VERIFICATION, INCOME_VERIFICATION } from 'src/assets/docs/my-verify';

import { ConsumersMyVerifyFields, ConsumersMyVerifyValues } from './types';
import { VERIFICATION_TYPES_OPTIONS } from './utils';

export const DEFAULT_PDF_SHOW = VERIFICATION_TYPES_OPTIONS[0].value;

export const CONSUMER_MY_VERIFY_INITIAL_FORM_VALUES: ConsumersMyVerifyValues = {
  [ConsumersMyVerifyFields.companyName]: '',
  [ConsumersMyVerifyFields.firstName]: '',
  [ConsumersMyVerifyFields.lastName]: '',
  [ConsumersMyVerifyFields.contactEmail]: '',
  [ConsumersMyVerifyFields.employers]: [],
  [ConsumersMyVerifyFields.noteToRecipient]: '',
};

export const MY_VERIFY_PDF_DOCUMENT = {
  [VerificationRequestType.VerificationOfEmployment]: EMPLOYMENT_VERIFICATION,
  [VerificationRequestType.VerificationOfIncome]: INCOME_VERIFICATION,
  [VerificationRequestType.GovernmentalVerification]: undefined,
} as const;
